import React from 'react';
import Select from "react-select";

export const StoreSelector = (props) => {

    const storeOptions = props.stores.map((store) => {
        return {value: store.gln, label: `${store.gln} - ${store.retailer.name}, ${store.city}`}
    });

    let selectedStore = storeOptions.find((option) => option.value === props.selectedStore);
    selectedStore = (selectedStore === undefined) ? null: selectedStore;

    const disabled = !props.selectedModule || props.selectedModule === '';

    return (
        <div className="row">
            <div className="col-lg-6" style={{zIndex: '900'}}>
                <label>Store</label>
                <Select
                    isDisabled ={disabled}
                    placeholder="Bitte wählen"
                    name="status"
                    value={selectedStore}
                    onChange={(store) => props.selectStore(store.value)}
                    options={storeOptions}
                />
            </div>
            <div className="col-lg-6">
            </div>
        </div>
    )

};

export default StoreSelector;


// WEBPACK FOOTER //
// ./src/admin/areacontrol/admin/StoreSelector.js